// extracted by mini-css-extract-plugin
module.exports = {"postLink":"LinkPTComponent_postLink__6FWKs"};